export { EloTextAlignLeftIcon } from './text-align-left-icon'
